/**
 * Created by zhaoxu on 2018/4/19.
 */
import bus from '@/data/event-bus'

export default function install(Vue) {
  Vue.prototype.$globalBus = bus;
}
